var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('header',{staticClass:"full-width d-flex justify-center pt-8"},[_c('LogoImage')],1),_c('main',{staticClass:"py-16 px-4",staticStyle:{"max-width":"1000px","margin":"auto"},domProps:{"innerHTML":_vm._s(_vm.consentForm)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }